import { t } from 'i18next';

const maxDocumentMbFileSize = Number(process.env['MAX_DOCUMENT_MB_FILE_SIZE']) || 50;

const MAX_FILE_SIZE = maxDocumentMbFileSize * 1024 * 1024; // 10 MB en bytes
const ALLOWED_EXTENSIONS = ['PDF', 'DOC', 'DOCX', 'TXT'];

const useUploadFileMethod = (isKnowledge = false) => {
    const validateFilesSize = (files: File[]) => {
        if (!isKnowledge && files.some((file) => file.size && file.size > MAX_FILE_SIZE)) {
            return {
                valid: false,
                error: t('toast.sizeError.description'),
            };
        }
        return { valid: true };
    };

    const validateFileExtension = (files: File[]) => {
        if (files.some((file) => !ALLOWED_EXTENSIONS.includes(file.name.split('.').pop()?.toUpperCase() || ''))) {
            return {
                validFileExtension: false,
                error: t('toast.extensionError.description'),
            };
        }
        return { validFileExtension: true };
    };

    const validateSingleFile = (file: File): string | null => {
        const ext = file.name.split('.').pop()?.toUpperCase() || '';
        if (!ALLOWED_EXTENSIONS.includes(ext)) {
            return t('toast.extensionError.description');
        }
        if (!isKnowledge && file.size && file.size > MAX_FILE_SIZE) {
            return t('toast.sizeError.description');
        }
        return null;
    };

    return {
        validateFilesSize,
        validateFileExtension,
        validateSingleFile,
    };
};

export default useUploadFileMethod;
